

import { initializeApp } from 'firebase/app';

import { getAuth } from 'firebase/auth';

import { getFirestore } from 'firebase/firestore';

import { getFunctions } from 'firebase/functions';

import { getStorage } from 'firebase/storage';


const firebaseConfig = {

  apiKey: "AIzaSyB34kQ9CF2kmENDsd7ElrrpRGnQ12S9uJE",

  authDomain: "defedesvinreact.firebaseapp.com",

  projectId: "defedesvinreact",

  storageBucket: "defedesvinreact.firebasestorage.app",

  messagingSenderId: "259471021257",

  appId: "1:259471021257:web:e906ab0f09643d72bd2918"

};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);

export const functions = getFunctions(app);

export const storage = getStorage(app);
